import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

export const HotelPromoPath: MainPath = '/coupons_hotel/:code?';
export const SkipassGroupsPath: MainPath = '/skipass_groups/:id?';
export const CheckoutCodesPath: MainPath = '/checkout_codes';

export const HotelPromoRoutes: MainNavRoute = {
  path: '/coupons_hotel',
  label: 'routes.coupons_hotel',
  icon: 'coupon',
  type: 1,
  permissions: [PERMISSIONS.HOTEL_COUPONS__LIST],
  children: [
    {
      hidden: true,
      path: ':id',
      permissions: [PERMISSIONS.HOTEL_COUPONS__DETAILS],
    },
  ],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24181/8a90722a713bf0a',
};

export const SkipassGroupsRoutes: MainNavRoute = {
  path: '/skipass_groups',
  label: 'routes.skipass_groups',
  icon: 'group',
  type: 1,
  permissions: [PERMISSIONS.SKIPASS_GROUPS__LIST],
  children: [
    {
      hidden: true,
      path: ':id',
      permissions: [PERMISSIONS.SKIPASS_GROUPS__DETAILS],
    },
  ],
};

export const CheckoutCodesRoute: MainNavRoute = {
  path: '/checkout_codes',
  label: 'routes.checkout_codes',
  icon: 'ticket',
  permissions: [],
  type: 0,
};
